import RFFIntegerField from './RFFIntegerField';

export default RFFIntegerField;



// WEBPACK FOOTER //
// ./src/components/form/RFFIntegerField/index.jsx